import { useSelectTheme } from "../../../store/state/theme";
import { defaultSvgProps, SvgProps } from "../type/props";

export const InvisibleIcon = (props?: SvgProps) => {
  const { color } = useSelectTheme();
  const { width, height, fill, style } = defaultSvgProps(props, {
    width: 16,
    height: 16,
    fill: color.textIcon.title,
    style: {
      flexShrink: 0,
    },
  });

  return (
    <svg
      width={width}
      height={height}
      style={style}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.0013 3.99948C10.528 3.99948 12.7813 5.41948 13.8813 7.66615C13.488 8.47948 12.9346 9.17948 12.2746 9.74615L13.2146 10.6861C14.1413 9.86615 14.8746 8.83948 15.3346 7.66615C14.1813 4.73948 11.3346 2.66615 8.0013 2.66615C7.15463 2.66615 6.3413 2.79948 5.57464 3.04615L6.67464 4.14615C7.10797 4.05948 7.54797 3.99948 8.0013 3.99948ZM7.28797 4.75948L8.66797 6.13948C9.04797 6.30615 9.35463 6.61281 9.5213 6.99281L10.9013 8.37281C10.9546 8.14615 10.9946 7.90615 10.9946 7.65948C11.0013 6.00615 9.65463 4.66615 8.0013 4.66615C7.75463 4.66615 7.5213 4.69948 7.28797 4.75948ZM1.3413 2.57948L3.12797 4.36615C2.0413 5.21948 1.1813 6.35281 0.667969 7.66615C1.8213 10.5928 4.66797 12.6661 8.0013 12.6661C9.01464 12.6661 9.98797 12.4728 10.8813 12.1195L13.1613 14.3995L14.1013 13.4595L2.2813 1.63281L1.3413 2.57948ZM6.3413 7.57948L8.0813 9.31948C8.05464 9.32615 8.02797 9.33281 8.0013 9.33281C7.0813 9.33281 6.33464 8.58615 6.33464 7.66615C6.33464 7.63281 6.3413 7.61281 6.3413 7.57948ZM4.07464 5.31281L5.2413 6.47948C5.08797 6.84615 5.0013 7.24615 5.0013 7.66615C5.0013 9.31948 6.34797 10.6661 8.0013 10.6661C8.4213 10.6661 8.8213 10.5795 9.1813 10.4261L9.83463 11.0795C9.24797 11.2395 8.63463 11.3328 8.0013 11.3328C5.47464 11.3328 3.2213 9.91281 2.1213 7.66615C2.58797 6.71281 3.26797 5.92615 4.07464 5.31281Z"
        fill={fill}
      />
    </svg>
  );
};
